import { useMutation, useQueryClient } from '@tanstack/react-query'
import { invalidateGroup } from '@/hooks/invalidation'
import { buylistMissing, selllistExtras } from '@/services/api/playset'
import type { PlaysetActionResponse, PlaysetParams, PlaysetScope } from '@/types'

export function useBuylistMissing() {
  const queryClient = useQueryClient()

  return useMutation<PlaysetActionResponse, Error, { scope: PlaysetScope; params: PlaysetParams }>({
    mutationFn: ({ scope, params }) => buylistMissing(scope, params),
    onSuccess: () => {
      invalidateGroup(queryClient, 'buylist')
      queryClient.invalidateQueries({ queryKey: ['dashboardStats'] })
    },
  })
}

export function useSelllistExtras() {
  const queryClient = useQueryClient()

  return useMutation<PlaysetActionResponse, Error, { scope: PlaysetScope; params: PlaysetParams }>({
    mutationFn: ({ scope, params }) => selllistExtras(scope, params),
    onSuccess: () => {
      invalidateGroup(queryClient, 'selllist')
      queryClient.invalidateQueries({ queryKey: ['dashboardStats'] })
    },
  })
}
